import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../AdminTabs/AdminAssignMentor/AdmMentor.css";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { ApiUrl } from "../../../ApiUrl";
import { fetchLoggedInTeacherOption } from "../../hooks/fetchLoggedInTeacherOption";

const getCurrentLocalDate = () => {
  const today = new Date();
  const localDate = new Date(
    today.getTime() - today.getTimezoneOffset() * 60000
  );
  return localDate.toISOString().split("T")[0];
};

const StaffStdMentorCommunication = () => {
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState(getCurrentLocalDate());
  const [communicationDetails, setCommunicationDetails] = useState("");
  const [students, setStudents] = useState([]);
  const [studentLoadError, setStudentLoadError] = useState("");
  const [saveError, setSaveError] = useState("");
  const maxCharacters = 5000;
  const [mentors, setMentors] = useState([]);
  const [selectedMentor, setSelectedMentor] = useState(null);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [selectedCommunicatedWith, setSelectedCommunicatedWith] =
    useState(null);
  const [selectedCommunicatedVia, setSelectedCommunicatedVia] = useState(null);

  const branchId = localStorage.getItem("branchId");
  const orgId = localStorage.getItem("orgId");
  const academicYearId = localStorage.getItem("academicSessionId");

  const handleClear = () => {
    setSelectedDate(getCurrentLocalDate());
    setSelectedStudent(null);
    setStudents([]);
    setSelectedCommunicatedWith(null);
    setSelectedCommunicatedVia(null);
    setCommunicationDetails("");
    setStudentLoadError("");
    setSaveError("");
  };

  useEffect(() => {
    const loadLoggedInMentor = async () => {
      try {
        const loggedInMentor = await fetchLoggedInTeacherOption();

        if (loggedInMentor) {
          setMentors([loggedInMentor]);
          setSelectedMentor(loggedInMentor);
        } else {
          setMentors([]);
          setSelectedMentor(null);
        }
      } catch (error) {
        console.error("Error fetching mentors:", error);
        setMentors([]);
        setSelectedMentor(null);
      }
    };

    loadLoggedInMentor();
  }, []);

  useEffect(() => {
    if (!selectedMentor) {
      setStudents([]);
      return;
    }

    const fetchStudents = async () => {
      try {
        setStudentLoadError("");
        const url = `${ApiUrl.apiurl}Mentor/mentorWiseStudentList/?academic_year_id=${academicYearId}&org_id=${orgId}&branch_id=${branchId}&teacher_id=${selectedMentor.value}`;
        const response = await fetch(url);
        const contentType = response.headers.get("content-type") || "";

        if (!response.ok) {
          const rawError = await response.text();
          throw new Error(
            rawError && rawError.trim().startsWith("<")
              ? "Mentor-wise student list API failed on the server."
              : rawError || "Unable to fetch students."
          );
        }

        if (!contentType.includes("application/json")) {
          throw new Error("Student API returned an unexpected response.");
        }

        const data = await response.json();

        if (data && data.data) {
          const formattedStudents = data.data.map((student) => ({
            value: student.student_id,
            label: student.student_name,
          }));
          setStudents(formattedStudents);
        } else {
          setStudents([]);
        }
      } catch (error) {
        console.error("Error fetching students:", error);
        setStudents([]);
        setSelectedStudent(null);
        setStudentLoadError(error.message || "Unable to fetch students.");
      }
    };

    fetchStudents();
  }, [selectedMentor, academicYearId, orgId, branchId]);

  const communicatedWithOptions = [
    { value: "student", label: "Student" },
    { value: "father", label: "Father" },
    { value: "mother", label: "Mother" },
  ];

  const communicatedViaOptions = [
    { value: "phone", label: "Phone " },
    { value: "email", label: "Email" },
    { value: "in person", label: "In Person" },
  ];

  const handleSave = async () => {
    if (
      !selectedDate ||
      !selectedMentor ||
      !selectedStudent ||
      !selectedCommunicatedWith ||
      !selectedCommunicatedVia ||
      !communicationDetails
    ) {
      alert("Please fill all required fields.");
      return;
    }

    setSaveError("");

    const localDate = new Date(selectedDate);
    const formattedDate = new Date(
      localDate.getTime() - localDate.getTimezoneOffset() * 60000
    )
      .toISOString()
      .split("T")[0];

    const payload = {
      date: formattedDate,
      teacher_id: selectedMentor.value,
      student_id: selectedStudent.value,
      communicated_with: selectedCommunicatedWith.value,
      communicated_via: selectedCommunicatedVia.value,
      remarks: communicationDetails,
      academic_year_id: academicYearId,
      org_id: orgId,
      branch_id: branchId,
    };

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}Mentor_Student_Communication/studentMentorCommunication/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (response.ok) {
        alert("Follow up created successfully");
        setSelectedDate(getCurrentLocalDate());
        setSelectedStudent(null);
        setSelectedCommunicatedWith(null);
        setSelectedCommunicatedVia(null);
        setCommunicationDetails("");
        setSaveError("");
      } else {
        const message = data.message || "Something went wrong!";
        setSaveError(message);
        alert(`Error: ${message}`);
      }
    } catch (error) {
      console.error("Error saving data:", error);
      setSaveError("Failed to save data.");
      alert("Failed to save data.");
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                STUDENT MENTOR
              </p>
              <div className="row mb-2 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSave}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>

                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={() => navigate("/staff/follow-up")}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1 mt-2">
                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="date" className="form-label">
                          Date
                        </label>
                        <input
                          type="date"
                          id="date"
                          className="form-control detail"
                          value={selectedDate || ""}
                          onChange={(e) => setSelectedDate(e.target.value)}
                          placeholder="Select date"
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="mentor" className="form-label ">
                          Mentor
                        </label>
                        <Select
                          id="mentor"
                          options={mentors}
                          className="detail"
                          value={selectedMentor}
                          isDisabled
                          placeholder="Logged-in mentor"
                          classNamePrefix="mentor-dropdown"
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="student-name" className="form-label ">
                          Student Name
                        </label>
                        <Select
                          id="student-name"
                          classNamePrefix="student-name-dropdown"
                          className="flex-grow-1 detail"
                          options={students}
                          placeholder="Select Student"
                          isDisabled={!selectedMentor}
                          value={selectedStudent}
                          onChange={setSelectedStudent}
                        />
                        {studentLoadError ? (
                          <small className="text-danger d-block mt-2">
                            {studentLoadError}
                          </small>
                        ) : null}
                      </div>

                      <div className="col-12 col-md-3 mb-4 ">
                        <label
                          htmlFor="communicated-with"
                          className="form-label"
                        >
                          Communicated With*
                        </label>
                        <Select
                          id="communicated-with"
                          classNamePrefix="communicated-with-dropdown"
                          className="flex-grow-1 detail"
                          options={communicatedWithOptions}
                          value={selectedCommunicatedWith}
                          onChange={setSelectedCommunicatedWith}
                          placeholder="Select "
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-4">
                        <label
                          htmlFor="communicated-via"
                          className="form-label "
                        >
                          Communicated Via*
                        </label>
                        <Select
                          id="communicated-via"
                          classNamePrefix="communicated-via-dropdown"
                          className="flex-grow-1 detail"
                          options={communicatedViaOptions}
                          placeholder="Select"
                          value={selectedCommunicatedVia}
                          onChange={setSelectedCommunicatedVia}
                        />
                      </div>

                      <div className="col-12 col-md-6 mb-4 mentor-communication-details">
                        <label
                          htmlFor="communication-details"
                          className="form-label"
                        >
                          Communication Details*
                        </label>
                        <textarea
                          id="communication-details"
                          className="detail mentor-communication-textarea"
                          rows="4"
                          maxLength={maxCharacters}
                          value={communicationDetails}
                          onChange={(e) =>
                            setCommunicationDetails(e.target.value)
                          }
                        />
                        <small className="text-muted mentor-communication-counter">
                          No. of characters left:{" "}
                          {maxCharacters - communicationDetails.length}
                        </small>
                        {saveError ? (
                          <small className="text-danger d-block mt-2">
                            {saveError}
                          </small>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffStdMentorCommunication;
